import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  missionControl: {
    id: 'components.HeaderUserMenuButton.missionControl',
    defaultMessage: 'Mission Control',
  },
  settings: {
    id: 'components.HeaderUserMenuButton.settings',
    defaultMessage: 'Settings',
  },
  uploadCenter: {
    id: 'components.HeaderUserMenuButton.uploadCenter',
    defaultMessage: 'Upload Center',
  },
  fileManagement: {
    id: 'components.HeaderUserMenuButton.fileManagement',
    defaultMessage: 'File Management',
  },
  nextyNext: {
    id: 'components.HeaderUserMenuButton.nextyNext',
    defaultMessage: 'Change to new look',
  },
  formResponses: {
    id: 'components.HeaderUserMenuButton.formResponses',
    defaultMessage: 'Form Responses',
  },
  messagingActivity: {
    id: 'components.HeaderUserMenuButton.messagingActivity',
    defaultMessage: 'Messaging Activity',
  },
  switchAccounts: {
    id: 'components.HeaderUserMenuButton.switchAccounts',
    defaultMessage: 'Switch Accounts',
  },
  logout: {
    id: 'components.HeaderUserMenuButton.logout',
    defaultMessage: 'Log Out',
  },
  openTicket: {
    id: 'components.HeaderUserMenuButton.openTicket',
    defaultMessage: 'View Tickets',
  },
});
